<template>
  <VView class="prizes" back-button-to="/menu" :header="$t('prizes.header')">
    <VBlock max-width="500px">
      <img src="@/assets/prizes.png" />
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'Prizes',
};
</script>

<style lang="scss" scoped>
.prizes {}
</style>
